var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visible"},[_c('button',{class:{'active': _vm.prevIsActive},attrs:{"data-obblur":"prevent"},on:{"click":_vm.prev}},[_vm._v(_vm._s(_vm.$t('common.back')))]),_c('button',{class:{'active': _vm.nextIsActive},attrs:{"data-obblur":"prevent"},on:{"click":_vm.next}},[_vm._v(_vm._s(_vm.$t('common.forward')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }